if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swiperElement = this.querySelector('.swiper');
      
      if(!this.swiperElement) return;

      const slideCount = Number(this.dataset.slideCount || 0);
      const shouldLoop = slideCount > 1;
      const pauseOnHover = this.hasAttribute('data-pause-on-hover');

      this.slider = new Swiper(this.swiperElement, {
        loop: shouldLoop,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        autoplay: shouldLoop
          ? {
              delay: 4500,
              disableOnInteraction: false,
              pauseOnMouseEnter: pauseOnHover,
            }
          : false,
        speed: 450,
      });
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
